import React, { useState, useRef, useEffect } from 'react';
import { PERMISSIONS } from './permissionMeta';

/**
 * Show/hide permission columns on the (wide) matrix. Session-only client state.
 * A checked item means the column is visible; unchecking adds it to `hidden`.
 *
 * Props: { hidden: string[], onToggle: (key) => void }
 */
const ColumnVisibilityMenu = ({ hidden = [], onToggle }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const hiddenCount = hidden.length;

  return (
    <div className="up-multiselect" ref={ref}>
      <button type="button" className="au-btn au-btn--ghost up-cols-trigger" data-testid="up-cols-trigger" onClick={() => setOpen((o) => !o)}>
        Columns{hiddenCount ? ` (${PERMISSIONS.length - hiddenCount}/${PERMISSIONS.length})` : ''} ▾
      </button>
      {open && (
        <div className="up-perm-menu up-cols-menu" data-testid="up-cols-menu">
          {PERMISSIONS.map((p) => (
            <label key={p.key} className="up-perm-item">
              <input
                type="checkbox"
                aria-label={p.label}
                checked={!hidden.includes(p.key)}
                onChange={() => onToggle(p.key)}
              />
              <span>{p.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnVisibilityMenu;
